type Props = {
  color?: string
  size?: string
}

export const LogoutIcon = (props: Props) => (
  <svg
    height={props.size || '1.6rem'}
    viewBox="0 0 24 24"
    width={props.size || '1.6rem'}
    xmlns="http://www.w3.org/2000/svg"
    style={{
      fill: 'none',
      stroke: props.color || 'var(--colors-black)',
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      strokeWidth: '1.5px',
    }}
  >
    <line x1="0.75" y1="12.004" x2="16.5" y2="12.004" />
    <polyline points="12.75 15.754 16.5 12.004 12.75 8.254" />
    <path d="M3.306,16.6a10.5,10.5,0,1,0,.179-9.542" />
  </svg>
)
